import { useLoaderData, useNavigate } from "react-router-dom";
import { useState } from "react";
import TextInput from "../../components/Selectors/TextInput";
import IconButton from "../../components/IconButton";
import { MdArrowLeft as Prev } from "react-icons/md";
import store from "../../store";
import { toast } from "react-toastify";
import { putDataApi } from "../../axios/DataManagementApi";
import { PrimaryButton } from "../Buttons/Button";
import { edit } from "../../reducers/dataSlice";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../utils/common";

const StructureEdit = () => {
  const { t } = useTranslation(["common", "button"]);
  const dataloaded = useLoaderData();
  const redirect = "/admin/structures";
  const [isLoading, setIsLoading] = useState(false);
  const history = useNavigate();
  const [item, setItem] = useState(dataloaded);
  const onChange = (name, value) => {
    setItem((prevState) => {
      return { ...prevState, [name]: value };
    });
  };
  return (
    <div className="m-8  rounded-lg bg-white px-8 pb-8  pt-4 shadow-lg">
      <div className="flex gap-x-1.5">
        <IconButton bg={true} Icon={<Prev size={40} />} value={""} callback={() => history(redirect)} />
        <h2 className="text-3xl font-semibold text-blue-900">{capitalizeFirstLetter(t("structure"))}</h2>
      </div>
      <div className={"grid grid-cols-2 gap-4  border-b pb-2"}>
        <TextInput name={"name"} value={item?.name} onChange={onChange} label={capitalizeFirstLetter(t("name"))} />
        <TextInput name={"description"} value={item?.description} onChange={onChange} label={capitalizeFirstLetter(t("description"))} />
      </div>
      <div className={"flex justify-end gap-2 pt-2 "}>
        <PrimaryButton
          isLoading={isLoading}
          label={t("edit", { ns: "button" })}
          callback={() => {
            setIsLoading(true);
            putDataApi("structure?structure_id=" + item["id"], item).then(() => {
              store.dispatch(edit({ type: "structures", updates: item, id: item["id"] }));
              toast.success("La structure a été modifié avec succès.");
              setIsLoading(false);
              history(redirect);
            });
          }}
        />
      </div>
    </div>
  );
};
export default StructureEdit;
